import React from 'react';
import { SCRIPT_CONTROLS } from 'components/EditorToolbar/controls/ScriptControl';
import Control from 'components/Toolbar/Controls/Control';
import { ControlState } from 'components/Toolbar/Controls/Control/constants';
import { ScriptType } from 'const';
import * as Models from 'models';
import { ControlMap } from './constants';

type Props = {
  styles: string[];
  toggleScriptStyle(style: ScriptType): void;
  controlState?: Models.ControlState;
  dataTestId?: string;
};

const ScriptStyle: React.FunctionComponent<Props> = (props) => {
  const {
    styles,
    toggleScriptStyle,
    controlState = ControlState,
    dataTestId = 'scriptStyle',
  } = props;

  return (
    <>
      {
        SCRIPT_CONTROLS.map(({ style }, index) => {
          const { icon, title } = ControlMap[style];

          return (
            <Control
              key={title}
              controlState={controlState}
              onToggle={toggleScriptStyle.bind(null, style)}
              state={styles.includes(style) ? controlState.ACTIVE : controlState.DEFAULT}
              title={title}
              type={icon}
              dataTestId={`${dataTestId}-control${index}`}
            />
          );
        })
      }
    </>
  );
};

export default ScriptStyle;
